module.exports = __webpack_public_path__ + "static/media/Anger.fb60a221.png";